import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import React, { useState } from 'react';

import ModalComponent from './archive-project-modal';

import Button from '~/client/components/base/button';
import { ArrowRight } from '~/client/components/base/icon';
import Arranger from '~c/components/base/arranger';
import { TableAction } from '~c/components/base/table';

interface Props {
  className?: string;
  entry: unknown;
  canDelete: boolean;
  onOpen: () => void;
  onDelete: (id: string) => void;
  deleteLoading: boolean;
}

export const ProjectRowActions: React.FC<Props> = ({
  className,
  entry,
  canDelete,
  onOpen,
  onDelete,
  deleteLoading,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    // The menu and dialog render in portals, but their clicks still bubble to the row's open handler.
    <Arranger
      direction="row"
      alignItems="center"
      onClick={(e) => e.stopPropagation()}
    >
      <TableAction tertiary>
        <Button icon={ArrowRight} aria-label="Open" onClick={onOpen} />
      </TableAction>
      {canDelete && (
        <>
          <IconButton
            aria-label="More actions"
            aria-haspopup="menu"
            aria-expanded={Boolean(menuAnchor)}
            size="small"
            sx={{ ml: 1 }}
            onClick={(e) => setMenuAnchor(e.currentTarget)}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={() => setMenuAnchor(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem
              disabled={deleteLoading}
              sx={{ color: 'error.main' }}
              onClick={() => {
                setMenuAnchor(null);
                setConfirmOpen(true);
              }}
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete…</ListItemText>
            </MenuItem>
          </Menu>
          <ModalComponent
            className={className}
            entry={entry}
            archiveProjectHandler={onDelete}
            archiveProjectLoading={deleteLoading}
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
          />
        </>
      )}
    </Arranger>
  );
};

export default ProjectRowActions;
